import { SingleMessageType } from "DataTypes/Chat.type";
import { CheckNumber, CheckStringEmpty } from "Utils/Common";

export const msgFormatter: (res: any) => SingleMessageType = (res) => {
  return {
    attachmentUrl: CheckStringEmpty(res?.attachmentUrl),
    case: CheckStringEmpty(res?.case),
    caseId: CheckNumber(res?.caseId),
    fileName: CheckStringEmpty(res?.fileName),
    isRead: res?.isRead,
    messageContent: CheckStringEmpty(res?.messageContent),
    messageType: CheckStringEmpty(res?.messageType),
    pkChatMessage: CheckNumber(res?.pkChatMessage),
    readAt: CheckStringEmpty(res?.readAt),
    senderUser: res?.senderUser,
    senderUserId: CheckNumber(res?.senderUserId),
    timestamp: CheckStringEmpty(res?.timestamp),
  };
};
